import { Component } from 'react';
import cc from 'classcat';

import loadingImg from './loading.gif';
import styles from './styles.module.scss';

class Loading extends Component {
  static state = {
    isClient: typeof window != 'undefined',
  };

  componentDidMount() {
    this.setState({ isClient: true });
  }

  render() {
    const { className } = this.props;
    return (
      <div className={cc([styles.container, className])}>
        <img src={loadingImg} className={styles.image} />
      </div>
    );
  }
}

export default Loading;
